module.exports = __webpack_public_path__ + "static/wrapper@2x-6eb674655b3dac099fdcac2107f3c654.png";